// extracted by mini-css-extract-plugin
export default {"iconFull":"Icons_iconFull__c22cM","iconEmpty":"Icons_iconEmpty__9npBs"};